<template>
    <Button :label="$t('view_history')" icon="pi pi-history" class="p-button-secondary p-button-sm mr-1" @click="onShowModal" />

    <CustomSidebar v-model:visible="showModal" position="bottom" :dismissable="false" :title="$t('history_log')" class="p-1" :blocked="blocked">
        <div class="flex" style="width:calc(100% - 2rem)">
            <div class="col-4 md-4 p-fluid">
                 <ScrollPanel style="width:100%;height:80vh">
                    <ModalData :data="orderData" v-if="orderData"/>
                </ScrollPanel>
            </div>
            <Divider layout="vertical" />
            <div class="col-8 md-4 p-fluid">
                <ScrollPanel style="width:100%;height: 80vh">
                    <DataTable :value="historyData" responsiveLayout="scroll">
                        <Column field="Status_From" :header="$t('status_from')"></Column>
                        <Column field="Status_To" :header="$t('status_to')"></Column>
                        <Column field="Created_Date" :header="$t('created_date')">
                            <template #body="{data}">
                                {{ this.$formatDateTime(data.Created_Date)}}
                            </template>
                        </Column>
                        <Column field="Created_By" :header="$t('created_by')"></Column>
                    </DataTable>
                </ScrollPanel>
            </div>
        </div>
    </CustomSidebar>    
</template>
<script>
    import ModalData from '../Helper/_ModalData.vue'

    export default {
        components: {
            'ModalData': ModalData
        },
        emits:['close'],
        props:{
            pData: {
                type: Object,
                default: null
            }
        },
        data(){
            return {
                showModal: false,
                historyData: [],
                blocked: false,
                orderData: null,
                dataUrl: "order/"
            }
        },
        mounted(){

        },
        methods:{
            reset(){

            },
            onShowModal(){
                this.showModal = true;
                this.reset();

                var self = this;

                this.$axios.get(this.$API_URL + this.dataUrl + this.pData[0].Id + "/" + this.$FORM_MODE_VIEW)
                    .then((response) => {
                        if (response.data.success) {
                            self.orderData = response.data.data.header;
                        }
                        else {
                            self.$parent.$toast.add({ severity: 'error', summary: "Error", detail: response.data.message, life: 120000});
                            //self.showAssignModal = false;
                        }
                        self.blocked = false;
                        
                    })
                    .catch(function (err) {
                        self.$parent.$toast.add({ severity: 'error', summary: "Error", detail: err.message, life: 120000});
                        self.blocked = false;
                        //self.showAssignModal = false;
                    });

                this.$axios.get(this.$API_URL + this.dataUrl + "view_history" + "/" + this.pData[0].Id)
                    .then((response) => {
                        if (response.data.success) {
                            self.historyData = response.data.data;

                            // if(self.orderData.Shipment_Type_Category == this.$SHIPMENT_TYPE_CATEGORY.INDIVIDUAL)
                            //     this.addDetail();

                            // self.isRelation = self.orderData.Is_Relation;
                            // self.isIndividual = self.orderData.Shipment_Type_Category == this.$SHIPMENT_TYPE_CATEGORY.INDIVIDUAL;
                            // self.isCollective = self.orderData.Shipment_Type_Category == this.$SHIPMENT_TYPE_CATEGORY.COLLECTIVE;
                            // self.transporter = self.orderData.Transporter_Code;
                            // self.location = self.orderData.Warehouse_Location_Code;
                        }
                        else {
                            self.$parent.$toast.add({ severity: 'error', summary: "Error", detail: response.data.message, life: 120000});
                            //self.showAssignModal = false;
                        }
                        self.blocked = false;
                        
                    })
                    .catch(function (err) {
                        console.log(err);s
                        self.$parent.$toast.add({ severity: 'error', summary: "Error", detail: err.message, life: 120000});
                        self.blocked = false;
                        //self.showAssignModal = false;
                    });

            },
            onClose(){
                this.showModal = false;
                this.$emit('close');
            },
        },
        computed:{
            isRelation() {
                return false;
            }
        }
    }

</script>